/**
 * True only for non-GET responses with a 5xx status. Drives the generic
 * "Something went wrong" snackbar — GETs and 4xx are handled by callers.
 */
export const isValidNonGet500Error = (error: unknown) => {
  return (
    // check that it exists
    (typeof error === 'object' &&
      error &&
      // check that it's 500
      'status' in error &&
      typeof error.status === 'number' &&
      error.status >= 500 &&
      // check that it non-get
      'config' in error &&
      typeof error.config === 'object' &&
      error.config &&
      'method' in error.config &&
      error.config.method !== 'get') === true // eq true to prevent boolean | null
  );
};
